module.exports = __webpack_public_path__ + "media/email.610f3a4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/app-website/assets/email.svg
// module id = ./src/templates/app-website/assets/email.svg
// module chunks = 0